module.exports = __webpack_public_path__ + "a6e18211316bf6efee076cd655d27649.png";